//import Container from 'typedi';
import axios from 'axios';
import sound from '../audio/alert.mp3';
import { canUserAccess } from '../utils/userAccess.js';
import moment from 'moment';
import { productFruits } from 'product-fruits';
import LogRocket from 'logrocket';
import { EVENT } from '../constants/utils';

export default {
  name: 'App',
  data() {
    return {
      nameEvents: 'Route events',
      pathBasic: 'Planification',
      loggedUser: null,
      isLogin: false,
      isLogged: false,
      totalAlerts: null,
      dataAlerts: null,
      currentView: null,
      onlyOnePopUp: 0,
      firstTime: 1,
      lastView: null,
      validateRefresh: 0,
      autoRefreshTimer: 0,
      autoRefreshTimerLimit: 300,
      dataAuth: {
        canNavRoute: false,
        canNavRouteBoard: false,
        canNavRouteFulfillment: false,
        canNavRouteAssignment: false,
        canNavRoutePreAssignment: false,
        canCreateRoute: false,
        canEditRoute: false,
        canDeleteRoute: false,
        canCancelRoute: false,
        canNavRouteEvents: false,
        canActivateTemplates: false,
        canDeleteTemplates: false,
        canEditTemplates: false,
        canNavTemplates: false,
        canScheduleTemplates: false,
        canViewTemplates: false,
        canNavClientNotification: false,
        canNavWebNotification: false,
        canNavGpsEvaluationTime: false,
        canNavReport: false,
        canNavIndicator: false,
        canNavSecureMode: false,
        canNavMotivesAndSubmotives: false,
        canNavPlanification: false,
        canNavTracking: false,
        canNavUser: false,
        canNavVehicle: false,
        canNavReportBasic: false,
        canNavClientNotificationBasic: false,
        canNavClientConfiguration: false,
        canNavTag: false,
        canCreateTag: false,
        canEditTag: false,
        canActivateTag: false,
        canNavSender: false,
        canCreateSender: false,
        canEditSender: false,
        canDeleteSender: false,
        canNavMotive: false,
        canCreateMotive: false,
        canEditMotive: false,
        canDeleteMotive: false,
        canNavVehicleType: false,
        canCreateVehicleType: false,
        canEditVehicleType: false,
        canDeleteVehicleType: false,
        isSuperUser: false,
        canNavBillingInformation: false,
        canNavRoutePreAssignmentUM: false,
        canNavCfdi: false,
        canNavIndicatorV2: false,
      },
      authPermissionList: {
        navRoute: 1,
        navRouteBoard: 2,
        navRouteFulfillment: 3,
        navRouteAssignment: 4,
        navRoutePreAssignment: 5,
        createRoute: 6,
        editRoute: 7,
        deleteRoute: 8,
        cancelRoute: 9,
        navRouteEvents: 10,
        activateTemplates: 11,
        deleteTemplates: 12,
        editTemplates: 13,
        navTemplates: 14,
        scheduleTemplates: 15,
        viewTemplates: 16,
        navClientNotification: 17,
        navWebNotification: 18,
        navGpsEvaluationTime: 19,
        navReport: 20,
        navIndicator: 21,
        navSecureMode: 22,
        navMotivesAndSubmotives: 23,
        navPlanification: 24,
        navTracking: 25,
        navUser: 26,
        navVehicle: 27,
        navReportBasic: 28,
        navClientNotificationBasic: 29,
        navClientConfiguration: 30,
        navTag: 31,
        createTag: 32,
        editTag: 33,
        activateTag: 34,
        navSender: 35,
        createSender: 36,
        editSender: 37,
        deleteSender: 38,
        navMotive: 39,
        createMotive: 40,
        editMotive: 41,
        deleteMotive: 42,
        navVehicleType: 43,
        createVehicleType: 44,
        editVehicleType: 45,
        deleteVehicleType: 46,
        navBillingInformation: 47,
        navTagTroncal: 48,
        createTagTroncal: 49,
        editTagTroncal: 50,
        activateTagTroncal: 51,
        navRoutePreAssignmentUM: 52,
        navIndicatorV2: 53,
      },
      timeoutID: null,
      socket: {},
      connectedStatus: 'Not connected!',
      message: 'No message yet!',
      alertSound: null,
      isGpsEvent: false,
      actualPopUpClick: null,
      idPopUp: 0,
      isBasicUser: false,
      canViewTroncal: false,
      canViewUM: false,
      subscriptionData: null,
    };
  },
  async created() {
    this.appVersion();
    this.checkCookieAt();
    await this.loginDashboard();
    await this.configurePF();
    this.configureRocket();
    // }
  },
  async mounted() {
    document.getElementsByClassName('vsm--toggle-btn').forEach((element) => {
      element.addEventListener('click', this.onToggleColapse);
    });
  },
  beforeDestroy() {
    // Limpia el temporizador cuando el componente se destruya
    this.clearTimeout();
  },
  methods: {
    appVersion() {
      const version = this.$store.getters.appVersion;
      console.log('Web version: ', version);
    },
    goHome() {
      if (this.pathBasic) {
        this.$router.push({ name: this.pathBasic }).catch(() => {});
      } else {
        this.$router.push({ name: 'RouteBoard' }).catch(() => {});
      }
    },
    async closeSession() {
      console.log('close session');
      this.deleteAllCookies();
      window.location.href = `${this.$store.getters.urlLogin}logout`;
    },
    deleteAllCookies() {
      // retrieve all cookies
      let Cookies = document.cookie.split(';');
      // set past expiry to all cookies
      for (let i = 0; i < Cookies.length; i++) {
        document.cookie = Cookies[i] + '=; expires=' + new Date(0).toUTCString();
      }
      document.cookie = 'at=; path=/; expires=' + new Date(0).toUTCString();
      document.cookie = 'idcliente=; path=/; expires=' + new Date(0).toUTCString();
      //Operaciones e I+D
      if (
        this.$store.getters.clientId &&
        (this.$store.getters.clientId == 582 ||
          this.$store.getters.clientId == 1040 ||
          this.$store.getters.clientId == 2492)
      ) {
        document.cookie = `newLogin=True; SameSite=Lax; path=/`;
      }
    },
    checkCookieAt() {
      const { query } = this.$route;
      let accessTokenCookie = this.readCookie('at');
      if (accessTokenCookie === null) {
        this.isLogin = true;
      }
      if (query && query.id_cliente && query.usuario && query.wpsid) {
        this.isLogin = false;
      }
    },
    async getSubscription() {
      let accessTokenCookie = this.readCookie('at');
      let idclient = this.readCookie('idcliente') ? this.readCookie('idcliente') : this.$store.getters.clientId;
      const urlsubscription = `${this.$store.getters.urlAPI}/subscription`;
      try {
        const config = {
          headers: {
            'id-client': idclient,
            Authorization: `Bearer` + accessTokenCookie,
          },
        };
        let subscriptionPromise = await axios.get(urlsubscription, config);
        if (subscriptionPromise.data.data !== '') {
          this.subscriptionData = subscriptionPromise.data.data[0];
          document.cookie = `enterprise=false; SameSite=Lax;`;
        } else {
          document.cookie = `enterprise=true; SameSite=Lax;`;
        }
      } catch (e) {
        if (!this.$store.getters.local) {
          document.cookie = `enterprise=true; SameSite=Lax;`;
        }
        console.log(e);
      }
    },
    validateDateExpiration() {
      if (this.subscriptionData && this.subscriptionData.subscriptionEndAt) {
        this.$store.commit('saveSubscriptionEndAt', this.subscriptionData.subscriptionEndAt);
        let result = false;
        let dateExpiration = new Date(this.subscriptionData.subscriptionEndAt);
        let dateExpirationTime = dateExpiration.getTime();
        let today = Date.now();
        if (today < dateExpirationTime) {
          result = true;
        }
        return result;
      }
      return true;
    },
    async loginDashboard() {
      this.alertSound = new Audio(sound);
      this.currentView = this.$route.name;
      this.$vToastify.getSettings();
      await this.checkSession();
      if (!this.isBasicUser) {
        const url = `${this.$store.getters.urlWebSocket}?clientId=${this.$store.getters.clientId}&token=${this.$store.getters.accessToken}`;
        this.socket = await new WebSocket(url);
        this.socket.onopen = () => {
          console.log('Websocket connected.');
          this.connectedStatus = 'Connected';
          this.sendMessage(JSON.stringify({ action: 'heartbeat' }));
        };
        await this.getConfigWeb();
        this.messageSocket();
        //Este listener construye un evento click para los links
        this.$vToastify.listen('vtStarted', async () => {
          await document.getElementById('idPopUp' + this.idPopUp).addEventListener('click', this.activeRouteModal);
        });
        this.$vToastify.listen('vtPaused', async (payload) => {
          this.actualPopUpClick = await payload.id;
        });
      }
    },
    /**
     * Metodo que configura el usuario y el rol que van a la plataforma de productFruits
     * Si se desean utilizar campos personalizados se puede usar el campo props
     * Mayor información en https://help.productfruits.com/en/article/identifying-users
     */
    async configurePF() {
      let role = '';
      if (this.canViewTroncal && this.canViewUM) {
        role = 'Troncal-UM';
      } else if (this.canViewTroncal) {
        role = 'Troncal';
      } else if (this.canViewUM) {
        role = 'UM';
      }
      const user = {
        username: this.loggedUser.userName ? this.loggedUser.userName : 'No encontrado',
        email: this.loggedUser.email ? this.loggedUser.email : 'No encontrado',
        firstname: this.loggedUser.firstName ? this.loggedUser.firstName : 'No encontrado',
        lastname: this.loggedUser.lastName ? this.loggedUser.lastName : 'No encontrado',
        role: role,
        props: {
          client: this.$store.getters.clientName ? this.$store.getters.clientName : 'No encontrado',
          country:
            this.$store.getters.client && this.$store.getters.client.countryName
              ? this.$store.getters.client.countryName
              : 'No encontrado',
        },
      };
      productFruits.init('Iehnjj43OQXomqlb', 'es', user);
      window.productFruitsReady = function () {
        console.log('Product Fruits is ready!');
      };
    },
    configureRocket() {
      if (process.env.NODE_ENV !== 'development') {
        LogRocket.init('rh60x4/last-mile');

        LogRocket.identify(this.loggedUser.userName, {
          name: this.loggedUser.userName ? this.loggedUser.userName : 'No encontrado',
          email: this.loggedUser.email ? this.loggedUser.email : 'No encontrado',
          subscriptionType: 'pro',
        });
      }
    },
    async getConfigWeb() {
      const urlNotification = `${this.$store.getters.urlAPI}/notification?notificationType=web`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const notificacionData = await axios.get(urlNotification, config);

        this.dataNotifications = notificacionData.data.data.types;
        this.dataConfigWeb = notificacionData.data.data.notifications;
        //Construye el body para las variables locales
        this.dataNotifications.forEach(async (type) => {
          const notification = this.dataConfigWeb.find((notification) => notification.idNotificationType === type.id);
          let enabled = false;
          const haveRecipientes = notification && notification.recipients;
          if (type.name === 'GPS_NOTIFICATION' || type.name === 'OPERATION_NOTIFICATION') {
            enabled = haveRecipientes ? !notification.recipients.includes(this.loggedUser.idUser) : true;
          } else {
            enabled = haveRecipientes ? notification.recipients.includes(this.loggedUser.idUser) : false;
          }
          const body = {
            isActive: enabled,
            idNotificationType: type.id,
            recipients: haveRecipientes ? notification.recipients : null,
          };
          if (type.name === 'GPS_NOTIFICATION') {
            await this.$store.commit('saveNotificationConfig', body);
          }
          if (type.name === 'GPS_SOUND') {
            await this.$store.commit('saveSoundConfig', body);
          }
          if (type.name === 'OPERATION_NOTIFICATION') {
            await this.$store.commit('saveNotificationWebConfig', body);
          }
          if (type.name === 'OPERATION_SOUND') {
            await this.$store.commit('saveSoundConfigWebNotification', body);
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * Metodo que se encarga de guardar el id de la ruta,
     * esto permite que al ir a tablero de rutas se abra el modal de la ruta correspondiente
     */
    activeRouteModal() {
      const idRoute = this.$vToastify.getToast(this.actualPopUpClick).idRoute;
      this.$store.commit('saveIdRouteFlash', idRoute);
    },
    messageSocket() {
      this.socket.onmessage = (event) => {
        // Se hace un parse de la data que llega a formato JSON
        const parsedMessage = JSON.parse(event.data);
        // Si los mensajes son distintos a undefined o hearbet te mostrara lo que recibio
        if (typeof parsedMessage !== 'undefined' && parsedMessage.message !== 'HEARTBEAT_RECEIVED') {
          this.message = parsedMessage;
          console.log(this.message);
          console.log('Se recibio respuesta del servidor!');
          this.message = this.makeSVGString(this.message);
          this.message = this.transformKeys(this.message);

          //Obtengo las configuraciones para las notificaciones el default es notificacciones true y sonido false
          const activeNotification = this.$store.getters.notificationConfig.isActive;
          const activeSound = this.$store.getters.soundConfig.isActive;
          const activeWebNotification = this.$store.getters.notificationWebConfig.isActive;
          const activeSoundWebNotification = this.$store.getters.soundConfigWebNotification.isActive;

          const maxSpeedNotification = this.$store.getters.maxSpeedNotification.isActive;
          const doorOpeningNotification = this.$store.getters.doorOpeningNotification.isActive;
          const exDetentionNotification = this.$store.getters.exDetentionNotification.isActive;
          const routeDepartureNotification = this.$store.getters.routeDepartureNotification.isActive;
          const panicNotification = this.$store.getters.panicNotification.isActive;
          const interfNotification = this.$store.getters.interfNotification.isActive;
          const disconnNotification = this.$store.getters.disconnNotification.isActive;
          const gpsLossNotification = this.$store.getters.gpsLossNotification.isActive;
          const speedNotification = this.$store.getters.speedNotification.isActive;

          this.isGpsEvent = this.message.eventType >= 101 && this.message.eventType <= 109;
          const isWebEvent = this.message.eventType >= 110 && this.message.eventType <= 111;
          const routerDirection = process.env.NODE_ENV !== 'development' ? '/lastmile/#/' : '/#/';

          let isMaxSpeed = false;
          let isDoorOpen = false;
          let isExDetention = false;
          let isRouteDeparture = false;
          let isPanic = false;
          let isInterf = false;
          let isDisconnection = false;
          let isGpsLoss = false;
          let isSpeed = false;

          isMaxSpeed = this.message.eventType === EVENT.EXCESO_VELOCIDAD_FLOTA;
          isDoorOpen = this.message.eventType === EVENT.APERTURA_PUERTA;
          isExDetention = this.message.eventType === EVENT.DETENCION_EXCESIVA;
          isRouteDeparture = this.message.eventType === EVENT.SALIDA_RUTA;
          isPanic = this.message.eventType === EVENT.BOTON_PANICO;
          isInterf = this.message.eventType === EVENT.INTEREFERENCIA_GPS;
          isDisconnection = this.message.eventType === EVENT.DESCONEXION_ELECTRICA;
          isGpsLoss = this.message.eventType === EVENT.PERDIDA_UBICACION_GPS;
          isSpeed = this.message.eventType === EVENT.EXCESO_VELOCIDAD;

          if (
            (activeSound && this.isGpsEvent) ||
            (activeSoundWebNotification && isWebEvent) ||
            (maxSpeedNotification && activeSound) ||
            (doorOpeningNotification && activeSound) ||
            (exDetentionNotification && activeSound) ||
            (routeDepartureNotification && activeSound) ||
            (panicNotification && activeSound) ||
            (interfNotification && activeSound) ||
            (disconnNotification && activeSound) ||
            (gpsLossNotification && activeSound) ||
            (speedNotification && activeSound)
          ) {
            this.alertSound.play();
          }
          if (
            (activeNotification && this.isGpsEvent) ||
            (activeWebNotification && isWebEvent) ||
            (maxSpeedNotification && isMaxSpeed) ||
            (doorOpeningNotification && isDoorOpen) ||
            (exDetentionNotification && isExDetention) ||
            (routeDepartureNotification && isRouteDeparture) ||
            (panicNotification && isPanic) ||
            (interfNotification && isInterf) ||
            (disconnNotification && isDisconnection) ||
            (gpsLossNotification && isGpsLoss) ||
            (speedNotification && isSpeed)
          ) {
            this.idPopUp += 1;
            //Formato de los pop ups
            const bodyHtml = `
              <div style='font-size: 12px'>
                ${this.message.idOpenDoor}
              </div>\n 
              <div style='font-size: 12px'>
                ${this.$t(`common.notification.route`)}
                ${this.message.nameRoute} (ID: ${this.message.idRoute})
              </div>\n 
              <div style='font-size: 12px'>
                ${this.message.idOpenDoorText}
              </div>\n 
              <div style='font-size: 12px'>
                ${this.$t(`common.notification.emitedDate`, {
                  date: this.getDate(this.message.initEvent)[0],
                  hour: this.getDate(this.message.initEvent)[1],
                })}\n 
                ${this.$t(`common.notification.vehicle`)}
                ${this.message.plate} 
                ${this.$t(`common.notification.driver`)} 
                ${this.message.driver}
              </div>
              <div class="mt-2" style="width:170px;padding: 5px;background: #E9EAFF;box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);border-radius: 3px;color: #6226F7;"><svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 0 25 25" width="25px" fill="#696CFF">  <path d="M0 0h24v24H0z" fill="none" />  <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" /></svg>
                <a style="margin-left:5px;color: #6226F7;"id=idPopUp${this.idPopUp} href=${routerDirection}>
                  ${this.$t(`common.notification.seeRoute`)}
                </a>
              </div>
            `;
            this.$vToastify.alertType({
              body: bodyHtml,
              title: this.getNameEvent(this.message.eventType - 101),
              idRoute: this.message.idRoute,
              icon:
                '<div style="background: rgba(0, 0, 0, 0.0001);box-shadow: inset 0px 2px 5px rgba(0, 0, 0, 0.1);;border-radius: 3px;height: 120px;display:flex;padding-left:5px;padding-right:5px;justify-content: center;align-items: center;">\n' +
                this.message.icon +
                '\n' +
                '</div>',
            });
          }
          if (this.$route.name === this.nameEvents && this.isGpsEvent) {
            this.$store.commit('saveNewEvent', this.message);
          } else if (this.isGpsEvent) {
            this.seeEvents([this.message]);
          }
        }
      };
    },
    async goToAnotherPage(path) {
      if (path != this.$router.name) {
        return this.$router.push({ name: path });
      }
    },
    /**
     * Metodo que activa el timer y llama al endpoint dependiendo de la vista en la que se encuentra
     */
    async incomingEvents() {
      if (this.currentView !== this.$route.name) {
        this.lastView = this.currentView;
        //Indica que la vista cambio por primera vez
        this.firstTime = 0;
        this.validateRefresh = 1;
        this.currentView = this.$route.name;
      }
      if (this.validateRefresh === 1) {
        if (this.currentView === this.nameEvents) {
          this.totalAlerts = null;
        } else {
          if (this.firstTime === 1) {
            const alerts = await this.getAlerts();
            this.seeEvents(alerts);
            this.autoRefreshTimer = 0;
            this.autoRefresh();
          }
        }
      }
      this.validateRefresh += 1;
    },
    async autoRefresh() {
      if (this.autoRefreshTimer <= this.autoRefreshTimerLimit) {
        this.timeoutID = setTimeout(() => {
          this.autoRefreshTimer += 1;
          this.autoRefresh();
        }, 1000);
      } else {
        if (this.$route.name === this.nameEvents) {
          this.autoRefreshTimer = 0;
          this.sendMessage(JSON.stringify({ action: 'heartbeat' }));
          console.log('Realizando heartBeat');
          this.autoRefresh();
        } else {
          this.autoRefreshTimer = 0;
          this.sendMessage(JSON.stringify({ action: 'heartbeat' }));
          console.log('Realizando heartBeat');
          const alerts = await this.getAlerts();
          this.seeEvents(alerts);
          this.autoRefresh();
        }
      }
    },
    clearTimeout() {
      // Cancela el temporizador si está activo
      if (this.timeoutID !== null) {
        clearTimeout(this.timeoutID);
      }
    },
    async seeEvents(alerts) {
      this.totalAlerts = null;
      let find = false;
      this.dataAlerts = alerts;
      let localAlerts = localStorage.getItem('eventsCheck');
      if (localAlerts !== null && localAlerts !== 'null') {
        let seeEvents = localAlerts.split(',');
        try {
          this.dataAlerts.forEach((event) => {
            find = false;
            for (let i = 0; i < seeEvents.length; i++) {
              if (i % 2) {
                if (event.initEvent === seeEvents[i] && event.plate === seeEvents[i - 1]) {
                  find = true;
                  return find;
                }
              }
            }
            if (!find) {
              if (this.totalAlerts === null) {
                this.totalAlerts = 1;
              } else {
                this.totalAlerts += 1;
              }
            }
          });
        } catch (e) {
          console.log(e);
        }
        console.log(
          'Alertas no revisadas: ',
          this.totalAlerts,
          ' alertas revisadas: ',
          seeEvents.length / 2,
          ' alertas recibidas: ',
          this.dataAlerts.length,
        );
      } else {
        this.totalAlerts = this.dataAlerts.length;
      }
    },
    changeLanguage(newLocale) {
      this.$i18n.locale = newLocale;
      document.getElementsByClassName('vsm--toggle-btn').forEach((element) => {
        element.addEventListener('click', this.onToggleColapse);
      });
      //this.updateSideBar();
    },
    updateSideBar() {
      this.menu[1].title = this.$t('common.rutas.dashboardRutas');
      this.menu[2].title = this.$t('common.rutas.sedes');
      this.menu[3].title = this.$t('common.rutas.pedidos');
      this.menu[4].title = this.$t('common.rutas.rutasPlanificadas');
      this.menu[5].title = this.$t('common.rutas.vehiculos');
      this.menu[6].title = this.$t('common.rutas.configuracion.raiz');
      this.menu[6].child[0].title = this.$t('common.rutas.configuracion.ubicaciones');
      this.menu[6].child[1].title = this.$t('common.rutas.configuracion.estados');
      this.menu[6].child[2].title = this.$t('common.rutas.configuracion.formularios');
      this.menu[6].child[3].title = this.$t('common.rutas.configuracion.eventos');
    },
    cleanFilter() {
      this.$store.commit('cleanFilter');
    },
    onToggleColapse() {
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 1000);
      window.dispatchEvent(new Event('resize'));
    },
    async getLoggedUserInfo(client) {
      /* --------------------------------------------
        Obtiene la data del usuario loggeado, en particular el id de usuario.
        Se usa el servicio Introspect del WaypointSession (POST http method)
        Se le provee con el AT - campo token=<AccessToken>
         */
      const url = this.$store.getters.introspect;
      const dataUser = await new Promise((resolve, reject) => {
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Host: 'demo',
          },
          body: 'token=' + encodeURIComponent(this.$store.getters.accessToken),
        })
          .then((res) => res.json())
          .then((dataUser) => {
            resolve(dataUser);
          })
          .catch((error) => {
            console.log('Al llamar API WaypointSession /introspect', error);
            reject(error);
          });
      });
      //this.$store.commit('saveLoggedUserData', dataUser);   <- Esto no estaba funcionando, asi que lo comente (Jorge Pizarro Tapia)
      if (dataUser['custom:id']) {
        this.loggedUser = {
          idUser: dataUser['custom:id'],
          firstName: dataUser['name'],
          lastName: dataUser['family_name'],
          userName: dataUser['client_id'],
          initialFirstName: dataUser['name'] ? dataUser['name'][0] : null,
          initialLastName: dataUser['family_name'] ? dataUser['family_name'][0] : null,
          email: dataUser['email'] ? dataUser['email'] : null,
        };
        //GO-2413 se movio el checkeo de la suscripción a este nivel, asi si el cliente no posee acceso,
        //se le bloquea el acceso antes de que empiece a construir el menu de permisos
        await this.getSubscription();
        if (!this.validateDateExpiration()) {
          this.$store.commit('saveDataAccess', null);
          this.setPermissionSubscriptionEnded();
          this.$router.push({ name: 'SubscriptionEnd' }).catch(() => {});
        } else {
          this.buildMenu();

          const urlSuperUser = `${this.$store.getters.urlAPI}/api/user/${dataUser['custom:id']}/kind`;
          const responseUser = await axios.get(urlSuperUser, {
            headers: {
              'id-client': this.$store.getters.clientId,
              Authorization: `Bearer ${this.$store.getters.accessToken}`,
            },
          });

          if (responseUser.data?.data?.load) {
            console.log('Usuario logeado es super usuario.');
            this.setSuperPermission();
          }
          this.validateClientInfo(client);
        }
      }
      this.$store.commit('saveIsUserReady', true);
      this.$store.commit('saveLoggedUser', this.loggedUser);
      this.$store.commit('saveUserId', this.loggedUser.idUser);
    },
    async getAlerts() {
      const urlAlert = `${this.$store.getters.urlAPI}/alert`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const alertPromise = await axios.get(urlAlert, config);
        return alertPromise.data.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    /**
     * Este metodo solo se utilizara si el cliente no tiene una suscripción vigente, al ser asi entonces todos los permisos se vacian
     */
    setPermissionSubscriptionEnded() {
      for (let key in this.dataAuth) {
        if (typeof this.dataAuth[key] === 'boolean') {
          this.dataAuth[key] = false;
        }
      }
    },
    setSuperPermission() {
      for (let key in this.dataAuth) {
        if (typeof this.dataAuth[key] === 'boolean') {
          this.dataAuth[key] = true;
        }
      }
      this.$store.commit('saveDataAccess', this.dataAuth);
    },
    buildMenu() {
      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navRoute)) {
        this.dataAuth.canNavRoute = true;
        //Esto es para indicar que puede navegar por troncal
        this.canViewTroncal = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede navegar por "Manejo de Rutas"`);
        this.pathBasic = 'Routes';
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navRouteFulfillment)) {
        this.dataAuth.canNavRouteFulfillment = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede navegar por "Cumplimiento de Actividades"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navRouteEvents)) {
        this.dataAuth.canNavRouteEvents = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede navegar por "Eventos"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navReportBasic)) {
        this.dataAuth.canNavReportBasic = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede navegar por "Reportes"`);
        this.pathBasic = 'Report';
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navRouteAssignment)) {
        this.dataAuth.canNavRouteAssignment = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede navegar por "Asignacion de Rutas"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navRoutePreAssignment)) {
        this.dataAuth.canNavRoutePreAssignment = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede navegar por "Preasignacion"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navRoutePreAssignmentUM)) {
        this.dataAuth.canNavRoutePreAssignmentUM = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede navegar por "Preasignacion" ultima milla`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.createRoute)) {
        this.dataAuth.canCreateRoute = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede "Crear Rutas"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.editRoute)) {
        this.dataAuth.canEditRoute = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede "Editar Rutas"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.deleteRoute)) {
        this.dataAuth.canDeleteRoute = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede "Eliminar Rutas"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.cancelRoute)) {
        this.dataAuth.canCancelRoute = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede "Cancelar Rutas"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.activateTemplates)) {
        this.dataAuth.canActivateTemplates = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Activar plantillas"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.deleteTemplates)) {
        this.dataAuth.canDeleteTemplates = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Eliminar plantillas"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.editTemplates)) {
        this.dataAuth.canEditTemplates = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Editar plantillas"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navTemplates)) {
        this.dataAuth.canNavTemplates = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede navegar por "Plantillas"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.scheduleTemplates)) {
        this.dataAuth.canScheduleTemplates = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Planificar plantillas"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.viewTemplates)) {
        this.dataAuth.canViewTemplates = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Ver detalle plantillas"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navClientNotification)) {
        this.dataAuth.canNavClientNotification = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Ver Notificaciones al cliente"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navWebNotification)) {
        this.dataAuth.canNavWebNotification = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Ver Notificaciones web"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navClientNotificationBasic)) {
        this.dataAuth.canNavClientNotificationBasic = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Ver Notificaciones al cliente Basico"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navClientConfiguration)) {
        this.dataAuth.canNavClientConfiguration = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Ver Configuración al cliente"`);
      }
      console.log(
        'Permisos de tag',
        this.authPermissionList.navTag,
        this.authPermissionList.navTagTroncal,
        this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navTagTroncal),
      );
      if (
        this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navTag) ||
        this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navTagTroncal)
      ) {
        this.dataAuth.canNavTag = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Ver mantenedor de atributos"`);
      }

      if (
        this.hasGrant(this.$store.getters.clientId, this.authPermissionList.createTag) ||
        this.hasGrant(this.$store.getters.clientId, this.authPermissionList.createTagTroncal)
      ) {
        this.dataAuth.canCreateTag = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Crear atributos"`);
      }

      if (
        this.hasGrant(this.$store.getters.clientId, this.authPermissionList.editTag) ||
        this.hasGrant(this.$store.getters.clientId, this.authPermissionList.editTagTroncal)
      ) {
        this.dataAuth.canEditTag = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Editar atributos"`);
      }

      if (
        this.hasGrant(this.$store.getters.clientId, this.authPermissionList.activateTag) ||
        this.hasGrant(this.$store.getters.clientId, this.authPermissionList.activateTagTroncal)
      ) {
        this.dataAuth.canActivateTag = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Activar atributos"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navSender)) {
        this.dataAuth.canNavSender = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Ver mantenedor de clientes"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.createSender)) {
        this.dataAuth.canCreateSender = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Crear clientes"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.editSender)) {
        this.dataAuth.canEditSender = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Editar clientes"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.deleteSender)) {
        this.dataAuth.canDeleteSender = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Eliminar clientes"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navMotive)) {
        this.dataAuth.canNavMotive = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Ver mantenedor de motivos"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.createMotive)) {
        this.dataAuth.canCreateMotive = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Crear motivos"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.editMotive)) {
        this.dataAuth.canEditMotive = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Editar motivos"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.deleteMotive)) {
        this.dataAuth.canDeleteMotive = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Eliminar motivos"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navVehicleType)) {
        this.dataAuth.canNavVehicleType = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Ver mantenedior tipo de vehículos"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.createVehicleType)) {
        this.dataAuth.canCreateVehicleType = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Crear tipo de vehículos"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.editVehicleType)) {
        this.dataAuth.canEditVehicleType = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Editar tipo de vehículos"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.deleteVehicleType)) {
        this.dataAuth.canDeleteVehicleType = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Eliminar tipo de vehículos"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navGpsEvaluationTime)) {
        this.dataAuth.canNavGpsEvaluationTime = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Ver Tiempo evaluacion GPS"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navReport)) {
        this.dataAuth.canNavReport = true;
        //console.log(`Cliente  ${this.$store.getters.clientId} puede "Ver Info. Historica"`);
        this.pathBasic = 'Report';
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navIndicator)) {
        this.dataAuth.canNavIndicator = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede "Ver Indicadores"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navSecureMode)) {
        this.dataAuth.canNavSecureMode = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede "Ver Viaje seguro"`);
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navMotivesAndSubmotives)) {
        this.dataAuth.canNavMotivesAndSubmotives = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede "Ver Motivos/Submotivos"`);
      }
      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navTracking)) {
        this.dataAuth.canNavTracking = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede "Ver Seguimiento"`);
        this.pathBasic = 'TrackingPlanification';
        //Esto es para indicar que puede navegar por UM
        this.canViewUM = true;
      }
      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navUser)) {
        this.dataAuth.canNavUser = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede "Ver Usuarios"`);
        this.pathBasic = 'User';
      }
      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navVehicle)) {
        this.dataAuth.canNavVehicle = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede "VerVehiculos"`);
      }
      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navPlanification)) {
        this.dataAuth.canNavPlanification = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede "Planificacion"`);
        this.pathBasic = 'Planification';
        //Esto es para indicar que puede navegar por UM
        this.canViewUM = true;
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navRouteBoard)) {
        this.dataAuth.canNavRouteBoard = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede navegar por "Tablero de Rutas"`);
        this.pathBasic = 'RouteBoard';
        //Esto es para indicar que puede navegar por troncal
        this.canViewTroncal = true;
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navBillingInformation)) {
        this.dataAuth.canNavBillingInformation = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede navegar por "Informacion de factura"`);
        this.pathBasic = 'RouteBoard';
      }

      if (this.hasGrant(this.$store.getters.clientId, this.authPermissionList.navIndicatorV2)) {
        this.dataAuth.canNavIndicatorV2 = true;
        //console.log(`Cliente ${this.$store.getters.clientId} puede navegar por "Indicadores Quicksight"`);
      }

      this.$router.push({ name: this.pathBasic }).catch(() => {});
      this.$store.commit('saveDataAccess', this.dataAuth);
    },
    hasGrant(client, auth) {
      return canUserAccess(client, auth, this.$store);
    },
    readCookie(name) {
      return (
        decodeURIComponent(
          document.cookie.replace(
            new RegExp('(?:(?:^|.*;)\\s*' + name.replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'),
            '$1',
          ),
        ) || null
      );
    },
    async getCookies() {
      const accessTokenCookie = this.readCookie('at');
      const refreshTokenCookie = this.readCookie('rt');
      await this.saveAccessTokenLocalStore(accessTokenCookie, refreshTokenCookie);
    },

    async saveAccessTokenLocalStore(accessTokenCookie, refreshTokenCookie) {
      const dateToken = new Date();
      if (accessTokenCookie !== null) {
        this.$store.commit('saveSession', true);
        this.$store.commit('saveDateToken', dateToken);
        this.$store.commit('saveAccessToken', accessTokenCookie);
        if (refreshTokenCookie) {
          this.$store.commit('saveRefreshToken', refreshTokenCookie);
        } else {
          this.$store.commit('saveRefreshToken', '');
        }
        await this.getPermissionsFromToken(accessTokenCookie);
      } else {
        if (this.$store.getters.local) {
          const [accessTokenWithoutSession, refreshTokenWithoutSession] =
            process.env.VUE_APP_SESSION_TOKEN.split(' , ');
          this.$store.commit('saveDateToken', dateToken);
          this.$store.commit('saveAccessToken', accessTokenWithoutSession);
          this.$store.commit('saveRefreshToken', refreshTokenWithoutSession);
          await this.getPermissionsFromToken(accessTokenWithoutSession);
        }
      }
    },
    getPermissionsFromToken(token) {
      const url = this.$store.getters.permissionsUrl;
      const data = { at: token };
      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Access-Control-Allow-Origin': '*',
        },
      };
      return new Promise((resolve, reject) => {
        axios
          .post(url, data, config)
          .then(({ data: { res }, status }) => {
            console.log('------------------------------permissions response');
            if (status === 200) {
              this.$store.commit('savePermissionUser', res);
              console.log('respuesta permisos:');
              console.log(res);
              resolve();
            }
            reject();
          })
          .catch((err) => {
            console.log({ err });
            reject();
          });
      });
    },
    async checkSession() {
      const { query } = this.$route;
      const publicRoutes = ['PrivacyPolicy'];
      const isPublicRoute = publicRoutes.includes(this.$route.name);
      if (!isPublicRoute) {
        if (query && query.id_cliente && query.usuario && query.wpsid) {
          const userName = query.usuario;
          const sessionId = query.wpsid;
          const idClient = query.id_cliente;
          try {
            console.log('actualizando cookie');
            const params = new URLSearchParams();
            params.append('wpsid', sessionId);
            params.append('user', userName);
            params.append('justToken', 'true');

            const config = {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
            };
            const response = await axios.post(this.$store.getters.introspect, params, config);
            if (response.data.token) {
              document.cookie = `at=${response.data.token}; SameSite=Lax;`;
              if (response.data.refreshToken) {
                document.cookie = `rt=${response.data.refreshToken}; SameSite=Lax;`;
              }
              document.cookie = `wpsid=${sessionId}; SameSite=Lax;`;
              document.cookie = `usrName=${userName}; SameSite=Lax;`;
              document.cookie = `idcliente=${idClient}; SameSite=Lax;`;
            }
          } catch (e) {
            console.log('error instrospect');
            window.location.href = `${this.$store.getters.urlLogin}`;
          }
        }
        if (query && query.id_cliente && query.usuario && query.at) {
          document.cookie = `at=${query.at}; SameSite=Lax;`;
          document.cookie = `wpsid=MOCK; SameSite=Lax;`;
          document.cookie = `usrName=${query.usuario}; SameSite=Lax;`;
          document.cookie = `idcliente=${query.id_cliente}; SameSite=Lax;`;
        }
        console.log('leyendo cookie');
        const regularExpCookie = '\\s*=\\s*([^;]+)';
        this.isBasicUser = document.cookie.match('(^|;)\\s*' + 'isBasicUser' + regularExpCookie)?.pop() || false;
        this.$store.commit('saveIsBasicUser', this.isBasicUser);

        if (this.$store.getters.local) {
          console.log('usando variables locales ', this.isBasicUser);
          this.isBasicUser
            ? this.$router.push({ name: this.pathBasic }).catch(() => {})
            : this.$router.push({ name: 'RouteBoard' }).catch(() => {});
          //función para modificar el cliente
          this.$store.commit('setClient', process.env.VUE_APP_CLIENT_ID || 2222);
        } else {
          if (document.cookie.trim().length) {
            const at = document.cookie.match('(^|;)\\s*' + 'at' + regularExpCookie)?.pop() || '';
            // validar data
            const parametros = new URLSearchParams();
            parametros.append('token', at);
            const configuracion = {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
            };
            try {
              const resultados = await axios.post(this.$store.getters.introspect, parametros, configuracion);
              const permisos = JSON.parse(resultados.data.permissions);
              const empresas = Object.keys(permisos);

              if (!resultados.data.active) {
                console.log('fallo del introspect con token');
                window.location.href = `${this.$store.getters.urlLogin}`;
              } else {
                const identificadorCliente =
                  document.cookie.match('(^|;)\\s*' + 'idcliente' + regularExpCookie)?.pop() || '';
                if (!empresas.includes(String(identificadorCliente))) {
                  console.log('no hay cliente');
                  window.location.href = `${this.$store.getters.urlLogin}`;
                } else {
                  console.log('empresa incluida');
                }
                this.$store.commit('setClient', identificadorCliente);
              }
            } catch (e) {
              console.log('error', e);
              window.location.href = `${this.$store.getters.urlLogin}`;
            }
          } else {
            // kickout
            console.log('kickout');
            window.location.href = `${this.$store.getters.urlLogin}`;
          }
        }
        await this.getCookies();
        await this.getClientApiKey();
        const client = await this.getClient();
        await this.getLoggedUserInfo(client);
        this.isLogged = true;
      }
    },
    async getClient() {
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
            //'x-api-key': Container.get('apiKey'),
          },
        };
        const response = await axios.get(
          `${this.$store.getters.urlAPI}/api/client/${this.$store.getters.clientId}`,
          config,
        );
        const client = response.data.data;
        let clientBody = {
          id: client.id,
          name: client.name,
          legalName: client.legalName,
          legalNumber: client.legalNumber,
          enabled: client.enabled,
        };
        if (client.address && client.address.country) {
          const country = client.address.country;
          clientBody = {
            ...clientBody,
            country: country.iso,
            countryName: country.name,
          };
          if (country.iso === 'MX') {
            this.dataAuth.canNavCfdi = true;
          }
        }
        this.$store.commit(
          'saveTimeZone',
          client.timezoneName ? client.timezoneName : Intl.DateTimeFormat().resolvedOptions().timeZone,
        );
        this.$store.commit('saveClient', clientBody);
        this.$store.commit('saveClientName', clientBody.name);
        console.log('ZONA  HORARIA', this.$store.getters.timeZone);

        return client;
      } catch (e) {
        console.log(e);
        this.$store.commit('saveClientName', '-');
        return null;
      }
    },
    validateClientInfo(client) {
      if (!client) return;
      if (client.legalName === client.legalNumber && client.legalNumber === client.name) {
        client.legalName = null;
        client.legalNumber = null;
      }
      if (
        (!client.legalName ||
          !client.legalNumber ||
          !client.giro ||
          !client.billingContactName ||
          !client.billingContactEmail) &&
        this.dataAuth.canNavClientConfiguration &&
        this.onlyOnePopUp === 0 &&
        !this.dataAuth.canNavSecureMode
      ) {
        this.idPopUp += 1;
        this.onlyOnePopUp += 1;
        const routerDirection =
          process.env.NODE_ENV !== 'development' ? '/lastmile/#/clientConfiguration' : '/#/clientConfiguration';
        const bodyHtml = `<div style='font-size: 12px'>
          ${this.$t('common.notification.updateClientBody')}
        </div>\n
        <div class="mt-2" style="width:170px;padding: 5px;background: #E9EAFF;box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);border-radius: 3px;color: #6226F7;"><svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#6226F7"><g><rect fill="none" height="24" width="24" x="0"/></g><g><g><g><path d="M21,10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-0.1c-2.73,2.71-2.73,7.08,0,9.79s7.15,2.71,9.88,0 C18.32,15.65,19,14.08,19,12.1h2c0,1.98-0.88,4.55-2.64,6.29c-3.51,3.48-9.21,3.48-12.72,0c-3.5-3.47-3.53-9.11-0.02-12.58 s9.14-3.47,12.65,0L21,3V10.12z M12.5,8v4.25l3.5,2.08l-0.72,1.21L11,13V8H12.5z"/></g></g></g></svg>
          <a style="margin-left:5px;color: #6226F7;"id=idPopUp${this.idPopUp} href=${routerDirection}>
            ${this.$t(`common.notification.goToConfigClient`)}
          </a>
        </div>`;
        this.$vToastify.alertType({
          body: bodyHtml,
          title: this.$t('common.notification.updateClient'),
          idRoute: 150,
          icon:
            '<div style="background: rgba(0, 0, 0, 0.0001);box-shadow: inset 0px 2px 5px rgba(0, 0, 0, 0.1);;border-radius: 3px;height: 120px;display:flex;padding-left:5px;padding-right:5px;justify-content: center;align-items: center;">\n' +
            '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>' +
            '\n' +
            '</div>',
        });
      }
    },
    async getClientApiKey() {
      console.log(this.$store.getters.clientId);
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(`${this.$store.getters.urlAPI}/api/apiKey`, config);
        const key = response.data.data;
        if (!key) {
          return;
        }
        this.$store.commit('saveClientApiKey', key);
      } catch (e) {
        console.log(e);
        this.$store.commit('saveClientApiKey', ' ');
      }
    },
    /**
     * Metodos utilizados para la personalizacion de los pop ups
     * @param {*} message
     * @returns
     */
    makeSVGString(message) {
      //(1) "Apertura de Puerta"
      if (message.eventType === EVENT.APERTURA_PUERTA) {
        message.icon =
          '<svg width="29px" height="29px" viewBox="0 0 29 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
          '<title>meeting_room_black_24dp</title>\n' +
          '<path d="M16.8980464,6.16666667 L16.8980464,27 L1.95604396,27 L1.95604396,24.2222222 L4.67277167,24.2222222 L4.67277167,2 L16.8980464,2 L16.8980464,3.38888889 L23.6898657,3.38888889 L23.6898657,24.2222222 L26.4065934,24.2222222 L26.4065934,27 L20.973138,27 L20.973138,6.16666667 L16.8980464,6.16666667 Z M11.7362637,13 L11.7362637,16 L14.6703297,16 L14.6703297,13 L11.7362637,13 Z" id="Shape" fill="#F17B1B" fill-rule="nonzero"></path> \n' +
          '</svg>';
      }
      //(2) "Detención Excesiva"
      if (message.eventType === EVENT.DETENCION_EXCESIVA) {
        message.icon =
          '<svg width="29px" height="29px" viewBox="0 0 29 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
          '<g id="Group" transform="translate(2.934066, 1.000000)" fill="#45A193" fill-rule="nonzero">\n' +
          '<rect id="Rectangle" x="7.17216117" y="0" width="7.17216117" height="2.38095238"></rect>\n' +
          '<path d="M19.1616239,7.60714286 L20.8590354,5.91666667 C20.3450305,5.30952381 19.7832112,4.73809524 19.1735775,4.23809524 L17.4761661,5.92857143 C15.6233578,4.45238095 13.2924054,3.57142857 10.7582418,3.57142857 C4.81730159,3.57142857 0,8.36904762 0,14.2857143 C0,20.202381 4.80534799,25 10.7582418,25 C16.7111355,25 21.5164835,20.202381 21.5164835,14.2857143 C21.5164835,11.7619048 20.631917,9.44047619 19.1616239,7.60714286 Z M11.953602,15.4761905 L9.56288156,15.4761905 L9.56288156,8.33333333 L11.953602,8.33333333 L11.953602,15.4761905 Z" id="Shape"></path>\n' +
          '</g>\n' +
          '</svg>';
      }
      //(3) "Exceso de Velocidad"
      if (message.eventType === EVENT.EXCESO_VELOCIDAD) {
        message.icon =
          '<svg width="29px" height="29px" viewBox="0 0 29 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
          '<title>speed_black_24dp</title>\n' +
          '<path d="M24.5117967,10.3946871 L23.0653745,12.5967658 C24.4822803,15.4572577 24.3850887,18.8468422 22.8066648,21.6193369 L6.5079563,21.6193369 C4.43415931,17.9778022 4.96438157,13.3907212 7.81265079,10.3321095 C10.66092,7.27349794 15.1534507,6.46689975 18.8672223,8.34734906 L21.0427353,6.8832643 C16.4845155,3.92466661 10.5195963,4.49913503 6.59438031,8.27475401 C2.66916434,12.050373 1.79844991,18.05102 4.48531715,22.8096497 C4.90290346,23.5417981 5.67276848,23.9948597 6.5079563,23.9999814 L22.7949053,23.9999814 C23.6384981,24.0033525 24.4192704,23.5491534 24.8410635,22.8096497 C27.0502603,18.935979 26.9276126,14.1356895 24.5235562,10.382784 L24.5117967,10.3946871 Z M12.9992168,18.5364267 C13.4403598,18.9834536 14.0389727,19.2346324 14.6631903,19.2346324 C15.2874079,19.2346324 15.8860209,18.9834536 16.3271638,18.5364267 L22.9830578,8.43067095 L12.9992168,15.1678415 C12.5575829,15.6143713 12.3094342,16.220294 12.3094342,16.8521341 C12.3094342,17.4839741 12.5575829,18.0898969 12.9992168,18.5364267 L12.9992168,18.5364267 Z" id="Shape" fill="#C21F64" fill-rule="nonzero"></path>\n' +
          '</svg>';
      }
      //(4) "Exceso de Velocidad por Flota"
      if (message.eventType === EVENT.EXCESO_VELOCIDAD_FLOTA) {
        message.icon =
          '<svg width="29px" height="29px" viewBox="0 0 29 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
          '<title>minor_crash_black_24dp</title>\n' +
          '<path d="M21.9722042,10.8870833 C21.733045,10.1741667 21.0633994,9.66666667 20.2741742,9.66666667 L7.12042042,9.66666667 C6.3311952,9.66666667 5.67350751,10.1741667 5.42239039,10.8870833 L2.93513514,18.125 L2.93513514,27.7916667 C2.93513514,28.45625 3.47324324,29 4.13093093,29 L5.32672673,29 C5.98441441,29 6.52252252,28.45625 6.52252252,27.7916667 L6.52252252,26.5833333 L20.8720721,26.5833333 L20.8720721,27.7916667 C20.8720721,28.45625 21.4101802,29 22.0678679,29 L23.2636637,29 C23.9213514,29 24.4594595,28.45625 24.4594595,27.7916667 L24.4594595,18.125 L21.9722042,10.8870833 Z M7.53894895,12.0833333 L19.8436877,12.0833333 L21.0873153,15.7083333 L6.29532132,15.7083333 L7.53894895,12.0833333 Z M6.52252252,21.1458333 C6.52252252,20.1429167 7.32370571,19.3333333 8.31621622,19.3333333 C9.30872673,19.3333333 10.1099099,20.1429167 10.1099099,21.1458333 C10.1099099,22.14875 9.30872673,22.9583333 8.31621622,22.9583333 C7.32370571,22.9583333 6.52252252,22.14875 6.52252252,21.1458333 Z M17.2846847,21.1458333 C17.2846847,20.1429167 18.0858679,19.3333333 19.0783784,19.3333333 C20.0708889,19.3333333 20.8720721,20.1429167 20.8720721,21.1458333 C20.8720721,22.14875 20.0708889,22.9583333 19.0783784,22.9583333 C18.0858679,22.9583333 17.2846847,22.14875 17.2846847,21.1458333 Z M10.6001862,6.04166667 L8.91411411,7.74541667 L5.32672673,4.12041667 L7.0127988,2.41666667 L10.6001862,6.04166667 Z M18.4804805,7.74541667 L16.7944084,6.04166667 L20.3817958,2.41666667 L22.0678679,4.12041667 L18.4804805,7.74541667 Z M14.8930931,6.04166667 L12.5015015,6.04166667 L12.5015015,0 L14.8930931,0 L14.8930931,6.04166667 Z" id="Shape" fill="#E6BC21" fill-rule="nonzero"></path>\n' +
          '</svg>';
      }
      //(5) "Desconexión Eléctrica"
      if (message.eventType === EVENT.DESCONEXION_ELECTRICA) {
        message.icon =
          '<svg width="29px" height="29px" viewBox="0 0 29 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
          '<title>power_off_black_24dp</title>\n' +
          '<path d="M21.2188529,16.9089474 L21.2188529,10.2631579 C21.2188529,9.05263158 20.0110991,7.83 18.8272613,7.84210526 L18.8272613,3 L16.4356697,3 L16.4356697,7.84210526 L11.6524865,7.84210526 L11.6524865,3 L9.26089489,3 L9.26089489,6.00210526 L20.6329129,17.5021053 L21.2188529,16.9089474 L21.2188529,16.9089474 Z M19.1142523,19.0515789 L8.30425826,8.08421053 L8.2923003,8.09631579 L4.4537958,4.21052632 L2.93513514,5.72368421 L6.95300901,9.79105263 C6.91713514,9.94842105 6.8693033,10.1057895 6.8693033,10.2631579 L6.8693033,16.8968421 L11.0545886,21.1578947 L11.0545886,24.7894737 L17.0335676,24.7894737 L17.0335676,21.1578947 L17.6075495,20.5768421 L22.9527568,26 L24.4594595,24.4505263 L19.1142523,19.0515789 L19.1142523,19.0515789 Z" id="Shape" fill="#0096CA" fill-rule="nonzero"></path>\n' +
          '</svg>';
      }
      //(6) "Pérdida de Ubicación GPS"
      if (message.eventType === EVENT.PERDIDA_UBICACION_GPS) {
        message.icon =
          '<svg width="29px" height="29px" viewBox="0 0 29 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
          '<title>share_location_black_24dp (1)</title>\n' +
          '<g id="Group" transform="translate(1.956757, 2.000000)" fill="#52D7C0" fill-rule="nonzero">\n' +
          '<path d="M12.9416791,21.5638191 L12.9416791,24 C15.3086286,23.758794 17.4636125,22.7939698 19.2064409,21.3346734 L17.5342677,19.6100503 C16.2271463,20.6472362 14.6609558,21.3467337 12.9416791,21.5638191 Z" id="Path"></path>\n' +
          '<path d="M2.35517363,12 C2.35517363,7.11557789 5.92326168,3.06331658 10.539402,2.4361809 L10.539402,0 C4.61614031,0.63919598 0,5.77688442 0,12 C0,18.2231156 4.61614031,23.360804 10.539402,24 L10.539402,21.5638191 C5.92326168,20.9366834 2.35517363,16.8844221 2.35517363,12 Z" id="Path"></path>\n' +
          '<path d="M21.1023557,10.7939698 L23.4810811,10.7939698 C23.2455637,8.36984925 22.3034943,6.16281407 20.8786142,4.37788945 L19.1946651,6.10251256 C20.2073897,7.42914573 20.8903901,9.03316583 21.1023557,10.7939698 Z" id="Path"></path>\n' +
          '<path d="M19.2064409,2.66532663 C17.4636125,1.20603015 15.2968527,0.24120603 12.9416791,0 L12.9416791,2.4361809 C14.6609558,2.65326633 16.2271463,3.35276382 17.5342677,4.38994975 L19.2064409,2.66532663 Z" id="Path"></path>\n' +
          '<path d="M19.1946651,17.9095477 L20.8786142,19.6221106 C22.3034943,17.8371859 23.2455637,15.6301508 23.4810811,13.2060302 L21.1023557,13.2060302 C20.8903901,14.9668342 20.2073897,16.5708543 19.1946651,17.9095477 Z" id="Path"></path>\n' +
          '<path d="M16.4508878,10.9145729 C16.4508878,7.91155779 14.2134729,5.96984925 11.7405405,5.96984925 C9.26760823,5.96984925 7.03019328,7.91155779 7.03019328,10.9145729 C7.03019328,12.9165829 8.59638375,15.2924623 11.7405405,18.0301508 C14.8846973,15.2924623 16.4508878,12.9165829 16.4508878,10.9145729 Z M11.7405405,12 C11.0457643,12 10.4805226,11.4211055 10.4805226,10.7095477 C10.4805226,9.99798995 11.0457643,9.41909548 11.7405405,9.41909548 C12.4353168,9.41909548 13.0005584,9.99798995 13.0005584,10.7095477 C13.0005584,11.4211055 12.4353168,12 11.7405405,12 Z" id="Shape"></path>\n' +
          '</g>\n' +
          '</svg>';
      }
      //(7) "Salida de Ruta"
      if (message.eventType === EVENT.SALIDA_RUTA) {
        message.icon =
          '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#648C9E"><path d="M0 0h24v24H0z" fill="none"/>\n' +
          '<title>verified_user_black_24dp</title>\n' +
          '<path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>\n' +
          '</svg>';
      }
      //(8) "Panico"
      if (this.message.alertType === 102) {
        this.message.eventType = EVENT.BOTON_PANICO;
        message.icon =
          '<svg width="29PX" height="29PX" viewBox="0 0 29 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
          '<title>radio_button_checked_black_24dp</title>\n' +
          '<path d="M14.5,8.45833333 C11.165,8.45833333 8.45833333,11.165 8.45833333,14.5 C8.45833333,17.835 11.165,20.5416667 14.5,20.5416667 C17.835,20.5416667 20.5416667,17.835 20.5416667,14.5 C20.5416667,11.165 17.835,8.45833333 14.5,8.45833333 Z M14.5,2.41666667 C7.83,2.41666667 2.41666667,7.83 2.41666667,14.5 C2.41666667,21.17 7.83,26.5833333 14.5,26.5833333 C21.17,26.5833333 26.5833333,21.17 26.5833333,14.5 C26.5833333,7.83 21.17,2.41666667 14.5,2.41666667 Z M14.5,24.1666667 C9.15916667,24.1666667 4.83333333,19.8408333 4.83333333,14.5 C4.83333333,9.15916667 9.15916667,4.83333333 14.5,4.83333333 C19.8408333,4.83333333 24.1666667,9.15916667 24.1666667,14.5 C24.1666667,19.8408333 19.8408333,24.1666667 14.5,24.1666667 Z" id="Shape" fill="#850F00" fill-rule="nonzero"></path>\n' +
          '</svg>';
      }
      //(9) "Interferencia"
      if (this.message.alertType === 103) {
        this.message.eventType = EVENT.INTEREFERENCIA_GPS;
        message.icon =
          '<svg width="29px" height="29px" viewBox="0 0 29 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
          '<title>sensors_off_black_24dp</title>\n' +
          '<path d="M9.83583333,13.2433333 C9.72708333,13.6420833 9.66666667,14.065 9.66666667,14.5 C9.66666667,15.8291667 10.2104167,17.0375 11.0804167,17.9195833 L9.36458333,19.6354167 C8.05958333,18.3183333 7.25,16.5058333 7.25,14.5 C7.25,13.37625 7.50375,12.325 7.95083333,11.3704167 L6.17458333,9.59416667 C5.31666667,11.0320833 4.83333333,12.7116667 4.83333333,14.5 C4.83333333,17.1704167 5.92083333,19.5870833 7.67291667,21.3270833 L5.95708333,23.0429167 C3.77,20.8558333 2.41666667,17.835 2.41666667,14.5 C2.41666667,12.035 3.15375,9.75125 4.4225,7.84208333 L1.67958333,5.09916667 L3.38333333,3.39541667 L25.5925,25.6045833 L23.88875,27.3083333 L9.83583333,13.2433333 Z M21.0491667,17.6295833 C21.49625,16.675 21.75,15.62375 21.75,14.5 C21.75,12.4941667 20.9404167,10.6816667 19.6233333,9.37666667 L17.9075,11.0925 C18.7895833,11.9625 19.3333333,13.1708333 19.3333333,14.5 C19.3333333,14.935 19.2729167,15.3579167 19.1641667,15.7566667 L21.0491667,17.6295833 Z M24.1666667,14.5 C24.1666667,16.2883333 23.6833333,17.9679167 22.8254167,19.4058333 L24.5775,21.1579167 C25.84625,19.24875 26.5833333,16.965 26.5833333,14.5 C26.5833333,11.165 25.23,8.14416667 23.0429167,5.95708333 L21.3270833,7.67291667 C23.0791667,9.41291667 24.1666667,11.8295833 24.1666667,14.5 Z" id="Shape" fill="#6226F7" fill-rule="nonzero"></path>\n' +
          '</svg>';
      }

      //(10) "actividad no realizada"
      if (this.message.eventType === 110) {
        message.icon =
          '<svg width="20px" height="20px" viewBox="0 0 11 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
          '<title>Oval</title>\n' +
          '<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
          '<g id="MVP2-Lm---Tablero-de-Rutas-+-conductores" transform="translate(-790.000000, -170.000000)"fill="#DE1616">\n' +
          '<g id="Inicio" transform="translate(234.000000, 90.000000)">\n' +
          '<g id="Indicadores" transform="translate(0.000000, 59.000000)">\n' +
          '<g id="Progress-Copy-3" transform="translate(556.000000, 16.000000)">\n' +
          '<circle id="Oval" cx="5.5" cy="10.5" r="5.5"></circle>\n' +
          '</g>\n' +
          '</g>\n' +
          '</g>\n' +
          '</g>\n' +
          '</g>\n' +
          '</svg>';
      }

      //(11) "Actividad realizada parcial"
      if (this.message.eventType === 111) {
        message.icon =
          '<svg width="20px" height="20px" viewBox="0 0 11 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
          '<title>Oval</title>\n' +
          '<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
          '<g id="MVP2-Lm---Tablero-de-Rutas-+-conductores" transform="translate(-790.000000, -170.000000)"fill="#E6BC21">\n' +
          '<g id="Inicio" transform="translate(234.000000, 90.000000)">\n' +
          '<g id="Indicadores" transform="translate(0.000000, 59.000000)">\n' +
          '<g id="Progress-Copy-3" transform="translate(556.000000, 16.000000)">\n' +
          '<circle id="Oval" cx="5.5" cy="10.5" r="5.5"></circle>\n' +
          '</g>\n' +
          '</g>\n' +
          '</g>\n' +
          '</g>\n' +
          '</g>\n' +
          '</svg>';
      }
      return message;
    },
    transformKeys(message) {
      message.nameRoute = message.routeName ? message.routeName : null;
      message.idRoute = message.routeId ? message.routeId : null;
      message.eventType = message.eventType ? message.eventType : null;
      message.plate = message.plate ? message.plate : null;
      message.driver = message.firstDriver ? message.firstDriver : null;
      message.initEvent = message.eventStartTime ? message.eventStartTime : null;
      message.endEvent = message.eventEndTime ? message.eventEndTime : null;
      message.lostTime = message.timeLost ? message.timeLost : null;
      message.lastConnection = message.lastConnectionTime ? message.lastConnectionTime : null;
      message.electricPowerSupply = message.electricalPowerSupply ? message.electricalPowerSupply : null;
      message.idClient = message.clientId ? message.clientId : null;
      message.idAssignation = message.assignationId ? message.assignationId : null;
      message.idOrigin = message.tripOriginZoneId ? message.tripOriginZoneId : null;
      message.idDestination = message.tripDestinationZoneId ? message.tripDestinationZoneId : null;
      message.nameOrigin = message.tripOriginZoneName ? message.tripOriginZoneName : null;
      message.nameDestination = message.tripDestinationZoneName ? message.tripDestinationZoneName : null;
      message.idOpenDoorText = message.idOpenDoor ? message.idOpenDoor : null;
      return message;
    },
    getNameEvent(typeEvent) {
      return this.$t(`common.eventTypesOptions[${typeEvent}]`);
    },
    /**
     * Transforma el timestamp del inicio del evento al formato fecha dd/mm/yyyy y la hora en hh:mm
     * @param {*} dateTimeStamp
     * @returns
     */
    getDate(dateTimeStamp) {
      if (dateTimeStamp !== '-' && dateTimeStamp !== null) {
        const dateEvent = moment(dateTimeStamp).format('DD/MM/YYYY');
        const hourEvent = moment(dateTimeStamp).format('HH:mm');
        return [dateEvent, hourEvent];
      }
      return dateTimeStamp;
    },
    /**
     * Este metodo se utiliza por si al momento de querer enviar el  mensaje, si este falla arroja un error de conexion
     * @returns
     */
    async waitForOpenConnection() {
      return new Promise((resolve, reject) => {
        const maxNumberOfAttempts = 10;
        const intervalTime = 200;

        let currentAttempt = 0;
        const interval = setInterval(() => {
          if (currentAttempt > maxNumberOfAttempts - 1) {
            clearInterval(interval);
            reject(new Error('Maximum number of attempts exceeded.'));
          } else if (this.socket.readyState === this.socket.OPEN) {
            clearInterval(interval);
            resolve();
          }
          currentAttempt++;
        }, intervalTime);
      });
    },
    /**
     * Metodo para enviar un mensaje por websocket, si el socket esta en un estado diferente a OPEN intentara esperar hasta que le permita enviar el mensaje o tirar un error
     * @param {*} message
     */
    async sendMessage(message) {
      if (this.socket.readyState !== this.socket.OPEN) {
        try {
          await this.waitForOpenConnection(this.socket);
          this.socket.send(message);
        } catch (err) {
          console.error(err);
          this.socket.close();
          const url = `${this.$store.getters.urlWebSocket}?clientId=${this.$store.getters.clientId}&token=${this.$store.getters.accessToken}`;
          this.socket = await new WebSocket(url);
          this.socket.onopen = () => {
            console.log('Websocket reconnected.');
            this.connectedStatus = 'Connected';
            this.sendMessage(JSON.stringify({ action: 'heartbeat' }));
          };
          this.messageSocket();
        }
      } else {
        this.socket.send(message);
      }
    },
  },
  computed: {
    menu() {
      const materialIcons = 'material-icons';
      return [
        {
          header: true,
          title: '',
          hiddenOnCollapse: true,
          collapsed: true,
        },
        /* {
          href: '/',
          title: this.$t('common.rutas.dashboardRutas'),
          icon: {
            element: 'span',
            class: materialIcons,
            text: 'dashboard',
          },
        }, */
        {
          href: '/indicatorV2',
          title: this.$t('common.rutas.indicatorV2'),
          attributes: {
            'data-navigation': 'route-board',
          },
          icon: {
            element: 'span',
            class: materialIcons,
            text: 'dashboard',
          },
          hidden: !this.dataAuth.canNavIndicatorV2 || this.$store.getters.clientId != 301,
        },
        {
          href: '/',
          title: this.$t('common.rutas.routeBoard'),
          attributes: {
            'data-navigation': 'route-board',
          },
          icon: {
            element: 'span',
            class: materialIcons,
            text: 'dashboard',
          },
          hidden: !this.dataAuth.canNavRouteBoard,
        },
        {
          href: '',
          title: this.$t('common.rutas.routesManagement'),
          attributes: {
            'data-navigation': 'route-management',
          },
          icon: {
            element: 'span',
            class: materialIcons,
            text: 'edit_location_alt',
          },
          hidden:
            !this.dataAuth.canNavRoute &&
            !this.dataAuth.canNavTemplates &&
            !this.dataAuth.canNavRouteAssignment &&
            !this.dataAuth.canNavRoutePreAssignment,
          child: [
            {
              href: '/routes',
              title: this.$t('common.rutas.addEdit'),
              attributes: {
                'data-navigation': 'add-edit',
              },
              hidden: !this.dataAuth.canNavRoute,
            },
            {
              href: '/template',
              title: this.$t('common.rutas.template'),
              attributes: {
                'data-navigation': 'template',
              },
              hidden: !this.dataAuth.canNavTemplates,
            },
            {
              href: '/routeAssignment',
              title: this.$t('common.rutas.routeAssignment.assignment'),
              attributes: {
                'data-navigation': 'route-assignment',
              },
              hidden: !this.dataAuth.canNavRouteAssignment,
            },
            // {
            //   href: '/vehiclePreassignment',
            //   title: this.$t('common.rutas.routeAssignment.preAssignment'),
            //   attributes: {
            //     'data-navigation': 'vehicle-preassignment',
            //   },
            //   hidden: !this.dataAuth.canNavRoutePreAssignment,
            // },
          ],
        },
        {
          href: '',
          title: this.$t('common.rutas.security'),
          attributes: {
            'data-navigation': 'security',
          },
          icon: {
            element: 'span',
            class: materialIcons,
            text: 'gpp_good',
          },
          hidden: !this.dataAuth.canNavSecureMode,
          child: [
            {
              href: '/secureMode',
              title: this.$t('common.rutas.secureMode'),
              attributes: {
                'data-navigation': 'secure-mode',
              },
              hidden: !this.dataAuth.canNavSecureMode,
            },
          ],
        },
        {
          href: '',
          title: this.$t('common.rutas.activities'),
          attributes: {
            'data-navigation': 'activities',
          },
          icon: {
            element: 'span',
            class: materialIcons,
            text: 'edit_calendar',
          },
          hidden: !this.dataAuth.canNavRouteFulfillment && !this.dataAuth.canNavMotivesAndSubmotives,
          child: [
            {
              href: '/routeFulfillment',
              title: this.$t('common.rutas.fulfillmentMainTitle'),
              attributes: {
                'data-navigation': 'route-fulfillment',
              },
              hidden: !this.dataAuth.canNavRouteFulfillment,
            },
            {
              href: '/motivesAndSubmotives',
              title: this.$t('common.rutas.motivesAndSubmotivesMainTitle'),
              attributes: {
                'data-navigation': 'motives-and-submotives',
              },
              hidden: !this.dataAuth.canNavMotivesAndSubmotives,
            },
          ],
        },
        {
          href: '/routeEvents',
          title: this.$t('common.rutas.eventsMainTitle', { totalAlerts: this.totalAlerts }),
          attributes: {
            'data-navigation': 'route-events',
          },
          icon: {
            element: 'span',
            class: materialIcons,
            text: 'notifications',
          },
          hidden: !this.dataAuth.canNavRouteEvents,
        },
        {
          href: '/queryBuilder',
          title: 'Vista para devs',
          attributes: {
            'data-navigation': 'route-events',
          },
          icon: {
            element: 'span',
            class: materialIcons,
            text: 'logo_dev',
          },
          hidden: !this.dataAuth.isSuperUser,
        },
        /* {
          href: '',
          title: this.$t('common.rutas.configuracion.raiz'),
          icon: {
            element: 'span',
            class: materialIcons,
            text: 'settings',
          },
          child: [
            {
              href: '/sample',
              title: titleSample,
            },
          ],
        }, */
        {
          href: '/basicPlan',
          title: this.$t('common.rutas.planification'),
          attributes: {
            'data-navigation': 'planification',
          },
          icon: {
            element: 'span',
            class: materialIcons,
            text: 'edit_location_alt',
          },
          hidden: !this.dataAuth.canNavPlanification,
        },
        {
          href: '',
          title: this.$t('common.rutas.tracking'),
          attributes: {
            'data-navigation': 'tracking-board',
          },
          icon: {
            element: 'span',
            class: materialIcons,
            text: 'ads_click',
          },
          hidden: !this.dataAuth.canNavTracking /*  || !this.dataAuth.canNavPlanification */,
          child: [
            {
              href: '/tracking',
              title: this.$t('common.rutas.rutasPlanificadas'),
              attributes: {
                'data-navigation': 'tracking-board',
              },
              hidden: !this.dataAuth.canNavTracking,
            },
            {
              href: '/operations',
              title: this.$t('common.rutas.operations'),
              attributes: {
                'data-navigation': 'operations',
              },
              hidden: !this.dataAuth.canNavTracking,
              //hidden: !this.dataAuth.canNavPlanification,
            },
          ],
        },
        {
          href: '',
          title: this.$t('common.rutas.reportData'),
          attributes: {
            'data-navigation': 'reports',
          },
          icon: {
            element: 'span',
            class: materialIcons,
            text: 'manage_search',
          },
          hidden: !this.dataAuth.canNavReport && !this.dataAuth.canNavIndicator,
          child: [
            {
              href: '/report',
              title: this.$t('common.rutas.report'),
              attributes: {
                'data-navigation': 'report',
              },
              hidden: !this.dataAuth.canNavReport,
            },
            {
              href: '/indicator',
              title: this.$t('common.rutas.indicator'),
              attributes: {
                'data-navigation': 'indicator',
              },
              hidden: !this.dataAuth.canNavIndicator,
            },
          ],
        },
        {
          href: '/report',
          title: this.$t('common.rutas.reportData'),
          attributes: {
            'data-navigation': 'reports',
          },
          icon: {
            element: 'span',
            class: materialIcons,
            text: 'manage_search',
          },
          hidden: this.dataAuth.canNavReport || !this.dataAuth.canNavReportBasic,
        },
      ];
    },
  },
  watch: {
    $route: function () {
      this.incomingEvents();
      if (!this.isLogged) {
        this.checkSession();
      }
    },
    '$store.getters.isUserReady': function () {
      if (this.$store.getters.isUserReady) {
        this.validateRefresh = 1;
        this.incomingEvents();
      }
    },
    socket: function () {
      if (this.socket.readyState === this.socket.CLOSED) {
        const url = `${this.$store.getters.urlWebSocket}?clientId=${this.$store.getters.clientId}&token=${this.$store.getters.accessToken}`;
        this.socket = new WebSocket(url);
        console.log('webSocket levantado de nuevo');

        this.socket.onopen = () => {
          console.log('Websocket connected.');
          this.connectedStatus = 'Connected';
          this.sendMessage(JSON.stringify({ action: 'heartbeat' }));
        };
        this.messageSocket();
      }
    },
  },
};
